import "./Reviews.scss";
import Review from "../../components/Review/Review";
import ReviewForm from "../../components/ReviewForm/ReviewForm";
import { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { API_URL } from "../../utils/axios";
import Loading from "../../components/Loading/Loading";

const Reviews = () => {
  const [loading, setLoading] = useState(true);
  const [reviews, setReviews] = useState("");

  const fetchAll = () => {
    axios
      .get(API_URL + "/review")
      .then((response) => {
        setReviews(response.data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    fetchAll();
  }, []);

  const review =
    !loading &&
    reviews
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      .map((item) => {
        return <Review review={item} key={item.id} />;
      });

  return (
    <Fragment>
      {loading && <Loading />}
      {!loading && (
        <div className="reviews">
          <h1 className="reviews__title">REVIEWS</h1>
          {review}
          <ReviewForm fetchAll={fetchAll} />
        </div>
      )}
    </Fragment>
  );
};

export default Reviews;
